/**
 * 人事管理建议意见
 */
export default Object.freeze({
    AGREE: '0', // 拟同意报领导审批
    DISAGREE: '1', // 建议暂缓
    REJECT: '2', // 退回
})